import React, { useState } from 'react';

import { useRecoilState } from 'recoil';

import { Dialog } from './styles';
import useSnackBar from 'hooks/useSnackBar';
import { ListDocumentsViewer } from 'components/ListDocumentsViewer';
import { DeleteDocument } from 'components/DeleteDocument';
import { listPdfsState } from 'modules/billing-center/contexts/atoms';
import { useDocuments } from 'modules/billing-center/hooks/useDocuments';

interface DocumentViewerModalProps {
  open: boolean;
  onClose: () => void;
  dealerId: number;
  updateDocumentsFunction?: () => void;
}

export const DocumentViewerModal = ({
  open,
  onClose,
  dealerId,
  updateDocumentsFunction,
}: DocumentViewerModalProps) => {
  const [stateListPdfs, setStateListPdfs] = useRecoilState(listPdfsState);
  const { handleSnackBarError } = useSnackBar();

  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [deleteDocumentId, setDeleteDocumentId] = useState<number | null>(null);
  const proposalId = stateListPdfs?.listPdfs?.[0]?.proposalId;

  const {
    getPdfDocumentsByProposalId,
    getPdfDocumentsByProposalIdLoading,
    deleteDocument,
    deleteDocumentLoading,
  } = useDocuments();

  const handleOpenModalDelete = ({ documentId }: { documentId: number }) => {
    setIsOpenModalDelete(true);
    setDeleteDocumentId(documentId);
  };

  const handleCloseModalDelete = () => {
    setIsOpenModalDelete(false);
  };

  const handleDeleteDocuments = async () => {
    try {
      if (deleteDocumentId) {
        await deleteDocument(
          { dealerId, documentId: deleteDocumentId },
          {
            onSuccess: () => {
              handleCloseModalDelete();
              setStateListPdfs(prev => ({
                ...prev,
                listPdfs: prev.listPdfs?.filter(
                  el => el?.id !== deleteDocumentId
                ),
              }));
              updateDocumentsFunction();
            },
          }
        );
      }
    } catch (error) {
      handleSnackBarError({
        type: 'error',
        message: 'Erro ao excluir documento. Tente novamente mais tarde.',
      });
    }
  };

  const handleDownloadDocuments = async ({
    documentIds,
  }: {
    documentIds: number[];
  }) => {
    try {
      const response = await getPdfDocumentsByProposalId({
        dealerId,
        proposalId,
        documentIds,
      });

      const blob = new Blob([response as BlobPart], {
        type: 'application/pdf',
      });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `documentos-${proposalId}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      handleSnackBarError({
        type: 'error',
        message: `Erro ao baixar documento. Tente novamente mais tarde.`,
      });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <ListDocumentsViewer
        onClose={onClose}
        listPdfs={stateListPdfs?.listPdfs}
        handleClickButtonDelete={handleOpenModalDelete}
        isLoading={stateListPdfs?.isLoading}
        handleDownloadDocuments={handleDownloadDocuments}
        isLoadingDownload={getPdfDocumentsByProposalIdLoading}
        hideSidebar
      />

      {!!isOpenModalDelete && (
        <DeleteDocument
          isOpen={isOpenModalDelete}
          onClose={handleCloseModalDelete}
          handleDeleteDocument={handleDeleteDocuments}
          deleteDocumentLoading={deleteDocumentLoading}
        />
      )}
    </Dialog>
  );
};
